import { React, useState, useEffect } from "react";
import { BiRightArrow } from "react-icons/bi";
import { CiPlay1 } from "react-icons/ci";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  NavLink,
  Outlet,
} from "react-router-dom";
import RenderFormList from "../RenderFormList";
import RenderNestedServicesWithForms from "../RenderNestedServicesWithForms";
import RenderAgentNestedServices from "./RenderAgentNestedServices";
// made for the service button in the services page option bar , may be reused later in other pages else should be renamed to servicebutton/link
function AgentOptionBarServiceButtonWithForms(props) {
  const { option, icon, forms, customPath } = props;

  // console.log(service);
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };
  return (
    <li key={option.serviceId}>
      <div className="d-flex align-items-baseline gap-1">
        {(option.subServices && option.subServices.length > 0) ||
        (option.offlineForms != undefined && option.offlineForms.length > 0) ? (
          <p className={`list-arrow ${isOpen ? "is-open" : ""}`} onClick={handleClick}>
            {<CiPlay1 size={12}  />}
          </p>
        ) : (
          <p className={"hidden-arrow"}>{<CiPlay1 size={12} />}</p>
        )}
        {icon}
        <p className={`nested-list-item `}>{option.name}</p>
      </div>
      {((option.subServices && option.subServices.length > 0) ||
        (option.offlineForms != undefined &&
          option.offlineForms.length > 0)) && (
        <RenderAgentNestedServices
          service={option}
          isOpen={isOpen}
          options={option.subServices}
          forms={option.offlineForms}
          icon={icon}
          customPath={customPath}
        />
      )}
    </li>
  );
}

export default AgentOptionBarServiceButtonWithForms;
